import type { Role } from "@/services/api/roles";
import RowActionsMenu from "@/components/ActionCells/RowActionsMenu";
import type { RowAction } from "@/components/ActionCells/RowActionsMenu";
import PencilIcon from "@/components/SVGComponents/PencilIcon";
import CrossIcon from "@/components/SVGComponents/CrossIcon";
import ShieldIcon from "@/components/SVGComponents/ShieldIcon";
import styles from "../TeamRoles.module.scss";

interface RoleCardProps {
  role: Role;
  onEdit: (role: Role) => void;
  onDelete: (role: Role) => void;
}

const getRoleRowActions = (
  role: Role,
  onEdit: (role: Role) => void,
  onDelete: (role: Role) => void,
): RowAction[] => [
  {
    key: "edit",
    label: "Edit role",
    icon: <PencilIcon />,
    onClick: () => onEdit(role),
  },
  {
    key: "delete",
    label: "Delete role",
    icon: <CrossIcon withBg={false} stroke="currentColor" strokeWidth={1.5} width={14} height={14} />,
    tone: "danger",
    dividerBefore: true,
    onClick: () => onDelete(role),
  },
];

const RoleCard = ({ role, onEdit, onDelete }: RoleCardProps) => {
  return (
    <div className={styles.mobileCard}>
      <div className={styles.mobileCardHeader}>
        <div className={styles.mobileRoleIconBadge}>
          <ShieldIcon width={18} height={18} />
        </div>

        <div className={styles.mobileAdminInfo}>
          <h3 className={styles.mobileRoleName}>{role.name}</h3>
        </div>

        <div className={styles.mobileCardActions}>
          <RowActionsMenu
            actions={getRoleRowActions(role, onEdit, onDelete)}
            ariaLabel={`Actions for ${role.name}`}
            triggerClassName={styles.mobileRowActionTrigger}
          />
        </div>
      </div>

      <div className={styles.mobileCardDivider} />

      <div className={styles.mobileRoleDescription}>
        <span className={styles.mobileFieldLabel}>Role Description</span>
        <p className={styles.mobileRoleDescText}>{role.description || "No description provided."}</p>
      </div>
    </div>
  );
};

export default RoleCard;
